import { render, staticRenderFns } from "./ProcedimientosForm.vue?vue&type=template&id=10b271a5"
import script from "./ProcedimientosForm.vue?vue&type=script&lang=js"
export * from "./ProcedimientosForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports